import SearchIcon from '../ui/svgs/SearchIcon';
import TrashIcon from '../ui/svgs/TrashIcon';

export default function IpInput(
    {title, value, placeHolder, error, isValid, buttonSearch, buttonClear,
        onSubmitHandler, onChangeHandler, clearHandle, message }) {

    return (
        <div className="row no-gutters pb-md-3 pb-1 border-radius mb-5">
        <div className="col">
            <div className="">
                {/* <h4 className="card-title text-6 line-height-2 ls-1 pt-3 
                font-weight-bold text-center text-color-primary">
                    {title} 
                </h4> */}
                {message && <p className="text-4 line-height-2 text-center text-color-danger"> {message} </p>}
                <form className="py-lg-3 py-1 row no-gutters form-geoip"
                    onSubmit={onSubmitHandler}>
                    <div className="form-label-group mb-0 geoip-input-item p-relative" >
                            <input className="form-control shadow"
                                onChange={onChangeHandler}
                                value={value}
                                type="text"
                                placeholder={placeHolder}
                                aria-label="form-control-lg example"
                                required
                                id="ip"
                                autoFocus={false}
                                />
                            <label htmlFor="ip"
                            className="mb-0"> {placeHolder} </label>
                            {error &&
                            <div className="invalid-feedback" 
                            style={{ display: "block" }}> {error} </div>}
                    </div>
                    <div className="geoip-button-group">
                        <button
                            type="submit"
                            disabled={!isValid}
                            className="ml-2 btn btn-primary btn-lg geoip-button-item shadow">
                            <SearchIcon />
                            <span className="d-none d-md-block mt-1"> {buttonSearch} </span>
                        </button>
                        <button
                            type="reset"
                            onClick={clearHandle}
                            className="ml-2 btn btn-danger btn-lg geoip-button-item shadow">
                               <TrashIcon width="1.6em" height="1.6em"/>
                                <span className="d-none d-md-block mt-1"> {buttonClear} </span>
                        </button>
                    </div>
                    
                </form>
            </div>
        </div>
    </div>
    )
}
